import dcapital from './dcapital.en';
export default {
  nav: { home: 'Home', selection: 'Trader Selection', training: 'Training', apply: 'Apply Now', signin: 'Sign in' },
  ticker: ['AAPL +1.24%', 'TSLA -0.87%', 'NVDA +2.41%', 'MSFT +0.66%', 'NASDAQ 18,412.55', 'NYSE 19,204.11', 'AMZN +1.02%', 'META -0.43%', 'GOOGL +0.95%', 'AMD +3.12%'],
  common: { result: 'Outcome', popular: 'Most popular', soldOut: 'Sold out', waitlistBtn: 'Join waitlist', soldOutHint: 'Group is full. Join the waitlist via the form.', choose: 'Choose plan', start: 'Start', orPaypal: 'or pay with' },
  home: {
    heroOverline: 'Professional trading platform · NYSE & NASDAQ',
    heroLines: ['Trade the', 'American', 'Stock Market'],
    heroSub: 'ALEF prop trading team. We train traders from scratch and recruit the best — qualify once and get funded with up to $1,000,000 in capital.',
    ctaPrimary: 'Get Selected',
    ctaSecondary: 'Training Program',
    stats: [
      { v: '$1M', l: 'Maximum capital', s: 'Grows as you stay consistent' },
      { v: '12 wks', l: 'Training program', s: 'Step-by-step NYSE & NASDAQ path' },
      { v: '1×', l: 'Qualify once', s: 'Your account scales automatically' },
    ],
    pillarsOverline: 'Three paths',
    pillarsTitle: 'Choose your way into trading',
    pillars: [
      { num: '01', title: 'Trader Selection', desc: 'Already trading? Prove consistency on a demo evaluation and get a live account that scales up to $1M.', cta: 'Apply for selection' },
      { num: '02', title: 'Training from Zero', desc: 'A three-month program: from market basics to your own trading system — with live sessions and mentor support.', cta: 'View the program' },
      { num: '03', title: 'Team Career', desc: 'Top graduates and selected traders trade company capital, grow their profit share and become mentors.', cta: 'Start the journey' },
    ],
    whyOverline: 'The market',
    whyTitle: 'Why NYSE & NASDAQ?',
    whyItems: [
      'The world’s largest and most liquid exchanges',
      'Apple, Microsoft, Google, Tesla and thousands more',
      'Over $50 trillion in market capitalization',
      'Trading opportunities daily, 9:30 AM – 4:00 PM EST',
      'Professional tools and real-time market data',
    ],
    benOverline: 'Advantages',
    benTitle: 'Why ALEF TRADERS',
    benefits: [
      { t: 'High-Performance Capital', d: 'Access to substantial trading capital based on your consistency and risk management.' },
      { t: 'Professional Support', d: 'A dedicated support team, advanced tools and institutional-grade infrastructure.' },
      { t: 'Flexible Profit Sharing', d: 'A competitive profit-split model that rewards consistency and discipline.' },
      { t: 'Career Growth', d: 'Advancement opportunities, mentorship and professional development inside the team.' },
    ],
    aboutOverline: 'About us',
    aboutName: 'ALEF TRADERS',
    aboutRole: 'A professional team of traders · NYSE & NASDAQ',
    aboutBio: 'ALEF Traders is a team of professional traders in the American stock market. We have been in the markets since 2012 and working professionally since 2017. During this time the team has managed a fund of over $10,000,000 and earned more than $3,000,000. Today we are growing our own prop team: we train traders from scratch and offer the best students and candidates who pass the selection the opportunity to trade company capital.',
    aboutStats: [
      { v: '2012', l: 'In markets since' },
      { v: '$10M+', l: 'Under management' },
      { v: '$3M+', l: 'Team profit' },
    ],
    ctaTitle: 'Ready to start your trading career?',
    ctaSub: 'Starting from scratch or bringing years of experience — we have the right path for you.',
    ctaBtn: 'Apply now',
  },
  selection: {
    overline: 'For experienced traders',
    heroLines: ['Prove your skill.', 'Get funded up', 'to $1,000,000'],
    heroSub: 'No interviews, no diplomas — only your trading. Pass the demo evaluation and trade company capital on NYSE & NASDAQ.',
    ctaBtn: 'Apply for selection',
    metrics: [
      { v: '$1M', l: 'Maximum capital' },
      { v: '30–50%', l: 'Profit share' },
      { v: '2', l: 'Evaluation stages' },
      { v: '9:30–16:00', l: 'EST session' },
    ],
    stepsOverline: 'Process',
    stepsTitle: 'How selection works',
    steps: [
      { num: '01', t: 'Application', d: 'Fill in a short form — tell us about your experience and the markets you trade.' },
      { num: '02', t: 'Demo stage', d: 'Trade a demo account under risk-management rules. Show consistency and hit the profit target.' },
      { num: '03', t: 'Verification', d: 'Confirm your result in a second stage with softer targets — we verify process, not luck.' },
      { num: '04', t: 'Live account', d: 'Get capital under management. Consistent trading scales your account — up to $1,000,000.' },
    ],
    condOverline: 'Conditions',
    condTitle: 'Rules of the game',
    conditions: [
      'Markets: NYSE & NASDAQ stocks',
      'Daily loss limit and overall drawdown limit',
      'Profit target per stage without breaching risk rules',
      'Account scaling for consistent performance',
      'Regular scheduled profit payouts',
    ],
    benOverline: 'Why us',
    benTitle: 'What a team trader gets',
    priceOverline: 'Participation fee',
    priceTitle: 'Trader selection — two formats',
    plans: [
      {
        key: 'online', name: 'Online', price: '$999', note: 'One-time payment: mini-course + evaluation',
        features: ['Trading mini-course — online access to recordings', 'Access to the demo evaluation stage', 'Result review and feedback from the team', 'On success — a live account with company capital', 'Capital scaling up to $1,000,000'],
        fit: 'Go through the selection from anywhere in the world at your own pace.',
      },
      {
        key: 'office', name: 'In office', price: '$1,499', note: 'One-time payment: everything online + working in the office', badge: true,
        features: ['Everything in the Online format', 'Fully equipped desk in our office for the entire selection period', 'Trade alongside the team in real time', 'Live trade reviews and daily contact with mentors', 'Immersion in the working environment of professional traders', 'Priority review of your results'],
        fit: 'For those who want to join the team as fast as possible and trade shoulder to shoulder with professionals.',
      },
    ],
    priceBtn: 'Pay & start the selection',
    payMethods: 'Pay by card (Stripe), PayPal or USDT (TRC20) — right after a short application',
    ctaTitle: 'Ready to get selected?',
    ctaSub: 'Leave an application — the team will contact you on Telegram within one business day.',
  },
  training: {
    badge: 'Cohort starts · January 18, 2027 · enrollment open',
    heroLines: ['Professional', 'trading', 'education'],
    heroSub: 'From your very first steps in the market to independent trading under mentor supervision.',
    ctaPrimary: 'Book a consultation',
    ctaSecondary: 'View plans',
    countdownTitle: 'Until cohort start:',
    countdownUnits: { d: 'days', h: 'hours', m: 'minutes', s: 'seconds' },
    stats: [
      { v: '3 mo.', l: 'Duration' },
      { v: 'Live', l: 'Online classes' },
      { v: 'Real', l: 'Market' },
      { v: 'Mentor', l: 'Guidance' },
    ],
    approachOverline: 'Our approach',
    approachQuote: '“We teach the profession of trading — we don’t sell dreams of quick riches.”',
    approachText1: 'Most courses are just a bundle of pre-recorded video lessons — theory with no feedback, no control and no guidance.',
    approachText2: 'Our program is built differently. The student walks the full path: beginner → practice → personal trading system → live trading.',
    compOverline: 'What’s inside',
    compTitle: 'Six components that make results predictable',
    components: [
      { t: 'Theory', d: 'Fundamental knowledge of markets, instruments and strategies.' },
      { t: 'Practice', d: 'Real charts, trade breakdowns, skill drills.' },
      { t: 'Feedback', d: 'Individual review of your mistakes and decisions.' },
      { t: 'Mentorship', d: 'Direct contact with an active professional trader.' },
      { t: 'Community', d: 'A private chat with mentors and graduates.' },
      { t: 'Guidance', d: 'Support while transitioning to a live account.' },
    ],
    princOverline: 'Why the program works',
    princTitle: 'Eight principles that set us apart from recorded courses',
    principles: [
      'Live real-time classes',
      'Ask questions during the lessons',
      'Recordings of every session — lifetime access',
      'Private community of practicing traders',
      'Breakdowns of real market situations',
      'Individual feedback on your trades',
      'Building your own trading system',
      'Guidance until you go live',
    ],
    roadOverline: 'Roadmap',
    roadTitle: 'Month 1 → Month 2 → Month 3',
    roadSub: 'Foundation → Practice → Live trading',
    months: [
      {
        num: '01', meta: '4 weeks · 3 classes per week · 1–1.5 hours', title: 'Trader Foundation',
        items: ['Introduction to financial markets', 'How trading works', 'Opening a brokerage account', 'Trading platform setup', 'Working with orders', 'Technical analysis', 'Trends and levels', 'Breakouts and reversals', 'Trading strategies', 'Risk management', 'Trading psychology'],
        result: 'The student understands the market and can analyze charts independently.',
      },
      {
        num: '02', meta: '4 weeks · 2 breakdowns per week + individual work · up to 2 hours', title: 'Practice & Your Own Trading System',
        items: ['Live practice sessions', 'Real-time market breakdowns', 'Review of participants’ trades', 'Mistake analysis', 'Additional theory', 'Individual feedback', 'Building your own system', 'Creating a trading plan'],
        result: 'The student gains a working decision-making system and prepares for independent trading.',
      },
      {
        num: '03', meta: '4 weeks · mentor guidance, 2 calls per week · 1–1.5 hours', title: 'Going Live',
        items: ['Preparation for live trading', 'Risk-management compliance control', 'Real trade breakdowns', 'Mentor supervision', 'Help with psychological adaptation'],
        result: 'The student starts trading independently under mentor supervision.',
      },
    ],
    formatOverline: 'Learning format',
    formatTitle: 'Live learning + recording archive',
    formatItems: [
      'All classes are held online via Zoom / Google Meet',
      'Session length — 1–1.5 hours, trade breakdowns up to 2 hours',
      'Live broadcast — ask questions during the class',
      'Every session is recorded',
      'Archive access for the entire program duration',
      'Re-watch the material anytime',
    ],
    commOverline: 'Private community',
    commTitle: 'A chat where people trade — not “motivate”',
    commItems: ['Mentors and practicing traders', 'Current cohort students', 'Program graduates', 'Market discussion, trade breakdowns, recommendations'],
    resOverline: 'What you get',
    resTitle: 'Nine concrete program outcomes',
    results: ['Training from zero', 'Live classes', 'Real-market practice', 'Recording access', 'Private chat', 'Individual feedback', 'Your own trading system', 'Mentor support', 'Live-trading preparation'],
    priceOverline: 'Participation plans',
    priceTitle: 'Choose your level of guidance',
    tiers: [
      {
        name: 'Group plan', price: '$2,599', size: 'Up to 20 participants', start: 'Starts 01/18/2027', startDate: '2027-01-18T09:00:00-05:00',
        features: ['Full 3-month course', 'All live sessions', 'Recordings for the duration of the course', 'Private chat', 'Basic feedback'],
        fit: 'For those who want a complete education at the most accessible price.',
      },
      {
        name: 'Small group', price: '$3,599', size: 'Up to 10 participants', start: 'Starts 01/18/2027', startDate: '2027-01-18T09:00:00-05:00', badge: true,
        features: ['Everything in the Group plan', '2x more mentor attention', 'Weekly review of your personal trades', 'Personal trading plan', 'Priority answers in chat', 'Recordings for 3 more months after the course'],
        fit: 'For those who want to reach consistent results faster through personal attention.',
      },
      {
        name: 'Individual', price: '$9,999', size: '1 on 1', start: 'Start anytime',
        features: ['6 months of support: 3 months of training + 3 months after', 'Personal program', 'One-on-one calls', 'Full review of every trade', 'Direct contact with the mentor', 'Maximum support'],
        fit: 'For those who need maximum results in minimum time.',
      },
    ],
    aboutOverline: 'About us',
    outOverline: 'Post-training results',
    outTitle: 'By the end of the program, the student can:',
    outcomes: ['Analyze the market independently', 'Identify entry points', 'Manage risk', 'Trade their own system', 'Control emotions', 'Keep a trading journal', 'Trade a live account with a clear plan', 'Make decisions like a professional'],
    ctaTitle: 'Start your trading journey today',
    ctaSub: 'Book a consultation and find out which training format fits you best.',
    ctaBtn: 'Apply now',
    ctaNote: 'We reply within one business day · 9:00–21:00 NY',
  },
  masterclass: {
    badge: 'Starts September 23',
    urgency: 'Only 3 spots left!',
    heroLines: ['3-day trading', 'master', 'class'],
    heroSub: '3 video lessons of 15–30 minutes + practical assignments. Suitable for beginners and experienced traders alike.',
    priceNow: '$59', priceOld: '$590', discount: '90% off',
    ctaBtn: 'Join the masterclass',
    bonus: 'Bonus after registration: how to get up to $1M in capital under management!',
    aboutOverline: 'Instructor',
    aboutTitle: 'About the masterclass & instructor',
    aboutText1: 'Greetings! I am a professional trader with many years of experience in financial markets. Throughout my career I have helped hundreds of people master the art of trading and start earning in the markets.',
    aboutText2: 'This 3-day masterclass is the result of my practical experience. Only proven strategies and real techniques that work for beginners and experienced traders alike.',
    forOverline: 'Audience',
    forTitle: 'Who this masterclass is for',
    forCards: [
      { t: 'For beginners', d: 'Learn trading basics from scratch, understand how markets work, and take your first steps under an experienced mentor.' },
      { t: 'For experienced traders', d: 'Sharpen your skills, learn advanced risk-management strategies and steadily grow your profit.' },
      { t: 'For extra income seekers', d: 'Trading is a way to build an additional income stream spending just 1–2 hours a day on the markets.' },
    ],
    getOverline: 'Contents',
    getTitle: 'What you will get',
    getItems: [
      { t: '3 video lessons', d: 'Daily 15–30-minute lessons with practical assignments.' },
      { t: 'Extra materials', d: 'Checklists, templates and useful learning resources.' },
      { t: 'Support', d: 'Access to a Telegram bot for materials and support.' },
      { t: 'Community', d: 'A private community of like-minded traders.' },
    ],
    progOverline: 'Program',
    progTitle: 'Masterclass curriculum',
    days: [
      { num: '1', label: 'Day 1', t: 'Start & entry strategies', d: 'Which markets to trade and why. Tools and workspace. Supply/demand zones and entry triggers. Common beginner mistakes.' },
      { num: '2', label: 'Day 2', t: 'Risk management & discipline', d: 'Position sizing. Stop-losses and take-profits. Scenario planning.' },
      { num: '3', label: 'Day 3', t: 'Trading psychology', d: 'Emotion control and handling losses. Discipline and trading routine. Building the mindset of a professional trader. Final checklist and the move to independent trading.' },
    ],
    bonusOverline: 'Special bonus',
    bonusNote: 'for those who complete the entire masterclass',
    bonusTitle: 'How to get up to $1M in capital under management',
    bonusText: 'An exclusive guide on passing prop-firm evaluations and getting up to one million dollars of trading capital under management.',
    achOverline: 'Outcomes',
    achTitle: 'What you will achieve',
    achieves: [
      { t: 'Consistency', d: 'Learn to trade steadily and confidently.' },
      { t: 'Profit', d: 'Start generating regular income.' },
      { t: 'Skills', d: 'Master professional techniques.' },
      { t: 'Confidence', d: 'Gain confidence in your decisions.' },
    ],
    resOverline: 'Cases',
    resTitle: 'Real results',
    resText: 'Student results after completing the masterclass and applying the system in practice.',
    cmpOverline: 'Comparison',
    cmpTitle: 'Why this masterclass',
    usTitle: 'This masterclass',
    themTitle: 'Other courses',
    us: ['Proven strategies from a practitioner', 'Only up-to-date 2026 information', 'Real cases and examples', 'Practical assignments every day', 'Access to the Telegram community', 'Bonus: the path to $1M capital'],
    them: ['Outdated textbook theory', 'Generic phrases without specifics', 'No practical examples', 'Just videos, no assignments', 'No support or community', 'Inflated price for basic info'],
    faqOverline: 'FAQ',
    faqTitle: 'Frequently asked questions',
    faqs: [
      { q: 'I’m a beginner — is this masterclass right for me?', a: 'Yes. The program goes from fundamentals to practice: markets, tools, entries, risk management and psychology. Experienced traders will fill the gaps and systematize their approach.' },
      { q: 'Do I need a large starting capital?', a: 'No. You can start small — what matters is the system and discipline. And the bonus guide shows how to get up to $1M of capital under management.' },
      { q: 'How much time do I need to dedicate to trading?', a: 'During the masterclass — 15–30 minutes per lesson plus 20–30 minutes per assignment each day. Afterwards, 1–2 hours a day is enough.' },
      { q: 'How do I get access to the materials?', a: 'Right after payment: lessons and materials are delivered via the Telegram bot, and the private chat link comes in your registration confirmation.' },
      { q: 'Is there a money-back guarantee?', a: 'Yes. A 48-hour money-back guarantee from the start. If you realize the format is not for you — we refund you, no questions asked.' },
    ],
    finalTitle: 'Join the masterclass right now',
    timerTitle: 'Offer ends in:',
    timerUnits: { h: 'hours', m: 'minutes', s: 'seconds' },
    ctaBtn2: 'Sign up now',
    ps: 'P.S. You risk nothing! Money-back guarantee — 48 hours from the start.',
    stickyBtn: 'Join with 90% off',
  },
  account: {
    prompt: 'Sign in to open your account',
    promptBtn: 'Sign in with Google',
    sub: 'You are signed in with your Google account',
    logout: 'Sign out',
    since: 'Member since',
  },
  pay: {
    title: 'Training payment',
    sub: 'Application received! Choose your plan and complete the payment to reserve your seat in the cohort — starts January 18, 2027.',
    chooseLabel: 'Choose your plan',
    payBtn: 'Proceed to payment',
    note: 'Secure payment via Stripe · After payment we will contact you on Telegram',
  },
  selPay: {
    title: 'Selection payment',
    sub: 'Application received! Choose your format and complete the payment — the team will then contact you on Telegram and open access to the mini-course and the demo stage.',
    chooseLabel: 'Choose a format',
  },
  crypto: {
    title: 'Pay with USDT',
    network: 'TRC20 network',
    walletLabel: 'Wallet',
    copy: 'Copy',
    copied: 'Copied',
    amount: 'Amount',
    hint: 'Send the exact amount to the wallet below, then press the button — we will verify the transfer and grant access.',
    paidBtn: 'I have sent the payment',
    modalTitle: 'Payment confirmation',
    modalSub: 'Enter your name and Telegram — we will verify the transaction and contact you.',
    send: 'Submit',
    success: 'Notification sent — we will verify your payment and contact you',
  },
  form: {
    title: 'Leave an application',
    name: 'Name', namePh: 'What should we call you',
    telegram: 'Telegram', telegramPh: '@username',
    email: 'Email', emailPh: 'you@example.com',
    phone: 'Phone', phonePh: '+1 555 000-0000',
    experience: 'Trading experience',
    expOptions: ['No experience', 'Less than 1 year', '1–3 years', 'More than 3 years'],
    message: 'Message (optional)', messagePh: 'A few words about your goal',
    submit: 'Submit application', sending: 'Sending…',
    successTitle: 'Application sent',
    successText: 'We will contact you within one business day.',
    waitlistTitle: 'Join the waitlist',
    waitlistSub: 'The small group is sold out. Leave your contacts — we will reach out as soon as a seat opens or a new cohort starts.',
    waitlistSuccessTitle: 'You are on the waitlist',
    waitlistSuccessText: 'We will contact you as soon as a seat becomes available.',
    error: 'Failed to send. Please try again.',
  },
  footer: {
    tagline: 'A professional team of traders. NYSE & NASDAQ.',
    links: 'Sections',
    risk: 'Risk warning: exchange trading involves the risk of losing capital. Past performance does not guarantee future results. The content is educational and is not investment advice.',
    rights: '© 2026 ALEF Traders. All rights reserved.',
    tgBtn: 'Telegram support',
    marketOpen: 'Market open',
    marketClosed: 'Market closed',
  },
  countdown: { label: 'Cohort starts in', d: 'days', h: 'hrs', m: 'min', s: 'sec' },
  dcapital,
  payment: {
    checking: 'Verifying your payment…',
    successTitle: 'Payment successful',
    successText: 'Access to the masterclass and the bonus guide “How to get up to $1M in capital” will arrive via the Telegram bot. Check your email and Telegram.',
    pendingText: 'Your payment is being processed — this page will refresh automatically.',
    successTextTraining: 'Your seat in the cohort is reserved. The team will contact you on Telegram within one business day and add you to the private chat.',
    successTextSelection: 'You are in! The team will contact you on Telegram within one business day and open access to the mini-course and the demo stage.',
    backHome: 'Back home',
    cancelTitle: 'Payment cancelled',
    cancelText: 'No worries — your spot is still reserved. You can complete the payment anytime while the discount lasts.',
    retry: 'Back to the masterclass',
    retryTraining: 'Back to training',
    retrySelection: 'Back to selection payment',
  },
};
